import { Component, OnInit } from '@angular/core';
import { HomeService } from '../../../services/home/home.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-shop-page',
  templateUrl: './shop-page.component.html',
  styleUrls: ['./shop-page.component.css']
})
export class ShopPageComponent implements OnInit {
  title = 'المتجر الالكتروني المتكامل';
  facts;
  isLoading = true;
  isData = false;
  isCustom = true;
  data;
  slides;
  works;

  constructor(private service: HomeService, private titleService: Title, private translateService: TranslateService) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.getWorks();
    this.facts = [
      {
        icon: "./../../../assets/images/android.png",
        title: this.translateService.instant("Develop android applications"),
        content: this.translateService.instant("We program Android applications using native languages; kotlin, using the latest technologies to ensure the quality and smoothness of dealing with the application and the possibility of its development with ease"),
      },
      {
        icon: "./../../../assets/images/apple.png",
        title: this.translateService.instant("Develop IOS applications"),
        content: this.translateService.instant("We program iPhone applications using native swift languages, using the latest technologies to ensure the quality and smoothness of dealing with the application and the possibility of its development with ease"),
      },
      {
        icon: "./../../../assets/images/online-shop.png",
        title: this.translateService.instant("Develop e-commerce website"),
        content: this.translateService.instant("We program electronic stores using the PHP language and the Angular framework, using the latest technologies to ensure the quality and smoothness of dealing with the store and the possibility of developing it with ease")
      }
    ];
  }

  getWorks() {
    this.service.getMarketWorks().subscribe(
      res => {
        this.data = res;
        this.works = this.data.andorid;

        this.isLoading = false;
        this.isData = true;
      }
    )
  }

}
